import { createAction, props, Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { WkfSupervisionParams } from '../../../models/workflow/wkf-supervision-params';



export class currentSupervisionActionConstant {
    static readonly LOAD_WKF_SUPERVISION_PARAMS_START='[Supervision]: LOAD_WKF_SUPERVISION_PARAMS_START';
    static readonly LOAD_WKF_SUPERVISION_PARAMS_FAILED='[Supervision]: LOAD_CURRENT_WKF_SUPERVISION_PARAMS_FAILED';
    static readonly LOAD_WKF_SUPERVISION_PARAMS_SUCCEED='[Supervision]: LOAD_WKF_SUPERVISION_PARAMS_SUCCEED';

    static readonly REMOVE_WKF_SUPERVISION_PARAMS_START='[Supervision]: REMOVE_WKF_SUPERVISION_PARAMS_START';
    static readonly REMOVE_WKF_SUPERVISION_PARAMS_FAILED='[Supervision]: REMOVE_WKF_SUPERVISION_PARAMS_FAILED';
    static readonly REMOVE_WKF_SUPERVISION_PARAMS_SUCCEED='[Supervision]: REMOVE_WKF_SUPERVISION_PARAMS_SUCCEED';
}

export const loadWkfSupervisionParamsStartAction = createAction(currentSupervisionActionConstant.LOAD_WKF_SUPERVISION_PARAMS_START);
export const loadWkfSupervisionParamsFailedAction = createAction(currentSupervisionActionConstant.LOAD_WKF_SUPERVISION_PARAMS_FAILED);
export const loadWkfSupervisionParamsSucceedAction = createAction(currentSupervisionActionConstant.LOAD_WKF_SUPERVISION_PARAMS_SUCCEED, props<{
    payload: WkfSupervisionParams
}>());

export const removeWkfSupervisionParamsStartAction = createAction(currentSupervisionActionConstant.REMOVE_WKF_SUPERVISION_PARAMS_START);
export const removeWkfSupervisionParamsFailedAction = createAction(currentSupervisionActionConstant.REMOVE_WKF_SUPERVISION_PARAMS_FAILED);
export const removeWkfSupervisionParamsSucceedAction = createAction(currentSupervisionActionConstant.REMOVE_WKF_SUPERVISION_PARAMS_SUCCEED)

@Injectable({
    providedIn: 'root'
})
export class CurrentSupervisionAction {

    constructor(private store: Store) {
    }

    public currentSupervisionWkfParamsStart(): void {
        this.store.dispatch(loadWkfSupervisionParamsStartAction());
    }

    public loadCurrentWkfSupervisionParams( wkfSupervisionParams: WkfSupervisionParams ) {

        if (!wkfSupervisionParams) {
            this.store.dispatch(loadWkfSupervisionParamsFailedAction());
        }
        this.store.dispatch(loadWkfSupervisionParamsSucceedAction({payload: wkfSupervisionParams}));

    }

    public removeCurrentWkfSupervisionParams( ) {
        this.store.dispatch(removeWkfSupervisionParamsSucceedAction());
    }
}